"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AUDIO_WEB_NAME = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _recorderJs = _interopRequireDefault(require("recorder-js"));

var _reactI18next = require("react-i18next");

var _MediaLength = _interopRequireDefault(require("./MediaLength"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var styles = {
  "formWrapper": "index__formWrapper",
  "formBtn": "index__formBtn",
  "formBtnCancel": "index__formBtnCancel",
  "formLink": "index__formLink",
  "withoutOpd": "index__withoutOpd",
  "formLabel": "index__formLabel",
  "formLabelRequired": "index__formLabelRequired",
  "formLabelOptional": "index__formLabelOptional",
  "formInput": "index__formInput",
  "formTextarea": "index__formTextarea",
  "formSection": "index__formSection",
  "formSectionRow": "index__formSectionRow",
  "formSectionBtn": "index__formSectionBtn",
  "error": "index__error",
  "compositeError": "index__compositeError",
  "fileInput": "index__fileInput",
  "fileControls": "index__fileControls",
  "formDateSelect": "index__formDateSelect",
  "formMoneySelect": "index__formMoneySelect",
  "amountField": "index__amountField",
  "currencyField": "index__currencyField",
  "imagePreview": "index__imagePreview",
  "dangerBtn": "index__dangerBtn",
  "dangerBtnDisabled": "index__dangerBtnDisabled",
  "fileList": "index__fileList",
  "fileItem": "index__fileItem",
  "downloadButton": "index__downloadButton",
  "downloadButtonDisabled": "index__downloadButtonDisabled",
  "fileButtonGroup": "index__fileButtonGroup",
  "timeIndicator": "index__timeIndicator",
  "modalButtonGroup": "index__modalButtonGroup"
};
var AUDIO_WEB_NAME = 'audio.webm';
exports.AUDIO_WEB_NAME = AUDIO_WEB_NAME;

var AudioFile = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(AudioFile, _Component);

  var _super = _createSuper(AudioFile);

  function AudioFile(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, AudioFile);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "cancel", function () {
      return _this.setState({
        audio: null
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "save", function () {
      return _this.props.onChange(_this.state.audio);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "start", function () {
      return _this.recorder.start().then(function () {
        return _this.setState({
          recording: true
        });
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "stop", function () {
      return _this.recorder.stop().then(function (_ref) {
        var blob = _ref.blob;
        blob.name = AUDIO_WEB_NAME;

        _this.setState({
          recording: false,
          audio: blob
        });
      });
    });
    _this.state = {
      recording: false,
      audio: null
    };
    _this.recorder = props.available ? new _recorderJs["default"](new (window.AudioContext || window.webkitAudioContext)(), {
      type: 'audio/webm'
    }) : null;
    return _this;
  }

  (0, _createClass2["default"])(AudioFile, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.available) {
        navigator.mediaDevices.getUserMedia({
          audio: true
        }).then(function (stream) {
          return _this2.recorder.init(stream);
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          available = _this$props.available,
          t = _this$props.t,
          disabled = _this$props.disabled;
      return /*#__PURE__*/_react["default"].createElement("div", null, available ? this.state.audio ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("audio", {
        controls: true
      }, /*#__PURE__*/_react["default"].createElement("source", {
        src: URL.createObjectURL(this.state.audio)
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: styles.modalButtonGroup
      }, /*#__PURE__*/_react["default"].createElement("button", {
        disabled: disabled,
        className: styles.formBtnCancel,
        type: "button",
        onClick: this.cancel
      }, t('cancel')), /*#__PURE__*/_react["default"].createElement("button", {
        disabled: disabled,
        className: styles.formBtn,
        type: "button",
        onClick: this.save
      }, t('save')))) : /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_MediaLength["default"], {
        recording: this.state.recording,
        data: this.state.data
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: styles.modalButtonGroup
      }, /*#__PURE__*/_react["default"].createElement("button", {
        disabled: disabled,
        className: styles.formBtn,
        onClick: this.state.recording ? this.stop : this.start
      }, this.state.recording ? t('stopRecording') : t('startRecording')))) : /*#__PURE__*/_react["default"].createElement("div", null, t('errors.audioPermission')));
    }
  }]);
  return AudioFile;
}(_react.Component);

var _default = (0, _reactI18next.withTranslation)()(AudioFile);

exports["default"] = _default;